import { NgClass } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-stage3nav',
  standalone: true,
  imports: [NgClass],
  templateUrl: './stage3nav.component.html',
  styleUrl: './stage3nav.component.css',
})
export class Stage3navComponent implements OnInit {
  @Input() currentTab = '';
  @Output() navigateTab: EventEmitter<string> = new EventEmitter<string>();
  recentTab: string;
  tabToSet:string;
  constructor(private router: Router) {}

  ngOnInit(): void {    
    this.recentTab = this.currentTab;
    this.setTab(this.recentTab)
  }

  navigateTo(route: string) {
    this.router.navigate([`/${route}`]).catch((err) => {
      console.error(`Navigation to ${route} failed:`, err);
    });
  }
  isActive(route: string): boolean {
    return this.router.url === `/${route}`;
  }
  setTab(currentTab: string) {
    this.navigateTab.emit(currentTab);
  }
}
